import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SITE } from "@/constants/testIds";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-background/70 border-b border-border/60"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid={SITE.navLogo}
          className="flex items-center gap-2.5 group"
        >
          <span className="relative inline-flex w-2 h-2 rounded-full bg-primary glow-pulse" />
          <span className="font-serif text-lg tracking-tight text-foreground/95">
            Shabbat Shalom, <span className="text-primary">America</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm">
          <a
            href="/#story"
            data-testid={SITE.navStory}
            className="text-foreground/70 hover:text-primary transition-colors duration-300"
          >
            The Story
          </a>
          <a
            href="/#listen"
            data-testid={SITE.navListen}
            className="text-foreground/70 hover:text-primary transition-colors duration-300"
          >
            Listen
          </a>
          <a
            href="/#join"
            data-testid={SITE.navJoin}
            className="text-foreground/70 hover:text-primary transition-colors duration-300"
          >
            Join the Release List
          </a>
          <Link
            to="/source-notes"
            data-testid={SITE.navSourceNotes}
            className="text-foreground/70 hover:text-primary transition-colors duration-300"
          >
            Source Notes
          </Link>
        </div>
      </nav>
    </header>
  );
};
